module.exports = __webpack_public_path__ + "static/media/lady-watching.1eba755c.png";